import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AboutComponent } from '@app/core/about/about.component';
import { Version } from '@app/core/about/version.model';
import { VersionService } from '@app/core/about/version.service';
import { AuthService } from '@app/core/auth/auth.service';
import { ConfirmationService } from '@app/core/confirmation/confirmation.service';
import { User } from '@app/core/user/model/User.model';
import { UserCV } from '@app/core/user/model/UserCV.model';
import { UserService } from '@app/core/user/user.service';
import { DropdownAirportSelectComponent } from '@app/features/common/airport/component/dropdown-airport-select/dropdown-airport-select.component';
import { Airport } from '@app/features/common/airport/model/airport.model';
import { AirportService } from '@app/features/common/airport/service/aiport.service';
import { DropdownSeasonSelectComponent } from '@app/features/common/season/component/dropdown-season-select/dropdown-season-select.component';
import { Season } from '@app/features/common/season/model/season.model';
import { SeasonService } from '@app/features/common/season/service/season.service';
import { AbstractComponent } from '@app/shared/component/AbstractComponent';
import { environment } from '@env/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { textChangeRangeIsUnchanged } from 'typescript';
import { TopBarService } from '../../services/top-bar.service';
import { ConfirmationResponse } from '@app/core/confirmation/confirmationResponse.model';
import { InfoService } from '@app/core/info/info.service';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent extends AbstractComponent implements OnInit {


  @ViewChild('dropdownAirportSelect') dropdownAirportSelect: DropdownAirportSelectComponent;
  @ViewChild('dropdownSeasonSelect') dropdownSeasonSelect: DropdownSeasonSelectComponent;


  @Output() topBarParameter = new EventEmitter();

  user: User;
  version: Version;
  airport: Airport;
  season: Season;
  defaultSeasoncode: string;
  onChrismas = false;

  time = new Date();
  intervalId: any;
  dw = false;

  constructor(
    public authService: AuthService,
    private confirmationService: ConfirmationService,
    public translateService: TranslateService,
    private modalService: NgbModal,
    public versionService: VersionService,
    private airportService: AirportService,
    private seasonService: SeasonService,
    private router: Router,
    private userService: UserService,
    private topBarService: TopBarService,
    private info: InfoService
  ) {
    super(authService, translateService);
  }

  ngOnInit(): void {
    this.user = this.authService.getUser();
    this.versionService.getVersion().subscribe(
      (version: Version) => {
        this.version = version;
        this.version.app = environment.version;
      }
    );
    const airport = this.airportService.getDefaultAirport();
    if (airport) {
      this.airport = airport;
    }
    this.airportService.defaultAirportChange.subscribe((defaultAirport: Airport) => {
      this.airport = defaultAirport;
    });
    const season = this.seasonService.getDefaultSeason();
    if (season) {
      this.season = season;
    }
    this.seasonService.defaultSeasonChange.subscribe((defaultSeason: Season) => {
      this.season = defaultSeason;
    });
    // cLOCK
    this.intervalId = setInterval(() => {
      this.time = new Date();
    }, 1000);

    const myDate = new Date();
    if ((myDate.getMonth()+1) === 12) {
      if (myDate.getDate() >= 15) {
        this.onChrismas = true;
      }
    } else if (myDate.getMonth() === 0) {
      if (myDate.getDate() <= 10) {
        this.onChrismas = true;
      }
    }
    if (this.getEnvironment() === 'dw') {
      this.dw = true;
    }
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }
  logout(): void {
    const user: User = this.authService.getUser();
    let userName = '';
    if (userName !== undefined && userName !== null) {
      userName = user.name;
    }
    this.confirmationService.confirm('common.auth.logout.confirmation', null)
    .then((confirmResponse: ConfirmationResponse) => {
      if (confirmResponse.ok) {
        this.authService.logout();
      }
    })
    .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

  about(): void {
    this.modalService.open(AboutComponent, { centered: true });
  }

  openNewTab() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/features'])
    );
  
    window.open(url, '_blank');
  }

  isAirport() {
    return this.user.type === UserCV.all.TYPE_AIRPORT;
  }
  isOperator() {
    return this.user.type === UserCV.all.TYPE_OPERATOR;
  }
  isAECFA() {
    return this.user.type === UserCV.all.TYPE_AECFA;
  }

  changePassword() {
    this.userService.openChangePassword(false, false);
  }

  sendParameter(parameter: string) {
    this.topBarService.sendTopBarParameter(parameter);
  }

  getEnvironment():string {
    return environment.envName;
  }
  getClassEnvironment() {
    let myEnvName = environment.envName;
    if (myEnvName === 'laptop') {
      myEnvName = 'prod';
    }
    return `environment${myEnvName} ${myEnvName === 'prod' ? 'bg-gradient-primary text-gray-100' : '' }`;
  }
  getNavlinkClassEnvironment() {
    return `navlink${environment.envName}`;
  }
}
